import { render, staticRenderFns } from "./UserRegistry.vue?vue&type=template&id=3502500f&"
import script from "./UserRegistry.vue?vue&type=script&lang=js&"
export * from "./UserRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports